import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { impostaFunzioni } from '../../../components/Util/featureFlags';

/*
 * Impostazioni › Funzioni: gli interruttori che prima erano variabili d'ambiente del backend e del
 * Manager (e per cambiarli serviva un deploy). Valgono per questo ambiente, entro un minuto in tutti i
 * servizi; il Manager si aggiorna subito.
 */

const FUNZIONI = [
    {
        chiave: 'sportsCatalogCreation',
        nome: 'Creazione di discipline nuove',
        testo: 'Il super admin può aggiungere sport al catalogo (Anagrafiche › Discipline).',
        rischio: true,
    },
    {
        chiave: 'moveGoalsManagement',
        nome: 'Gestione dei traguardi',
        testo: 'Creare, cancellare e cambiare soglie e trofei dei traguardi. Spento si cambia solo la descrizione.',
        rischio: true,
    },
    {
        chiave: 'newNotificationTypes',
        nome: 'Tipi di notifica nuovi',
        testo: 'Le notifiche nuove dell\'app Player: certificato approvato, fattura pronta, promemoria del giorno prima, invito al team accettato, convocazione dell\'assemblea, evento spostato, quota sociale in scadenza.',
        rischio: true,
    },
    {
        chiave: 'assemblies',
        nome: 'Assemblee',
        testo: 'Il modulo Assemblee delle strutture. Spento, al suo posto compare «In arrivo».',
    },
    {
        chiave: 'purchaseLinks',
        nome: 'Link di acquisto',
        testo: 'Il pulsante «Link di acquisto» dei prodotti e la voce «Link prodotti» del menu delle strutture.',
    },
];

const token = () => {
    try { return JSON.parse(sessionStorage.getItem('userDetails')).idToken; } catch { return ''; }
};
const chiama = async (method, data) => {
    const base = String(process.env.REACT_APP_API_BASE_PATH || '').replace(/\/+$/, '');
    try {
        const r = await axios.request({ method, url: `${base}/administration/settings/features`, data, headers: { authorization: token(), accept: 'application/json', 'Content-Type': 'application/json' } });
        return r.data;
    } catch (e) {
        return { error: e.response?.data?.detail || e.response?.data?.message || 'Errore generico' };
    }
};

export const Funzioni = () => {
    const [valori, setValori] = useState(null);
    const [errore, setErrore] = useState('');
    const [conferma, setConferma] = useState(null);
    const [salvato, setSalvato] = useState(false);

    useEffect(() => {
        chiama('get').then((r) => {
            if (!r || r.error) { setErrore(r?.error || 'Impossibile leggere gli interruttori.'); return; }
            setValori(r);
        });
    }, []);
    useEffect(() => {
        if (!salvato) return undefined;
        const t = setTimeout(() => setSalvato(false), 2500);
        return () => clearTimeout(t);
    }, [salvato]);

    const salva = async (chiave, acceso) => {
        setConferma(null);
        const prima = valori;
        const nuovi = { ...valori, [chiave]: acceso };
        setValori(nuovi);
        const r = await chiama('put', nuovi);
        if (!r || r.error) { setValori(prima); setErrore(r?.error || 'Salvataggio non riuscito.'); return; }
        setValori(r);
        impostaFunzioni(r);
        setSalvato(true);
    };

    // Accendere una funzione che le app vecchie non reggono chiede conferma; spegnerla no
    const cambia = (f, acceso) => (acceso && f.rischio ? setConferma(f) : salva(f.chiave, acceso));

    if (!valori) {
        return errore
            ? <Card><Card.Body>{errore}</Card.Body></Card>
            : <div className="text-center py-5"><Spinner animation="border" role="status" /></div>;
    }

    return (
        <>
            <Modal show={!!errore} onHide={() => setErrore('')} centered>
                <Modal.Header closeButton><Modal.Title>Errore durante l'operazione</Modal.Title></Modal.Header>
                <Modal.Body>{errore}</Modal.Body>
            </Modal>
            <Modal show={!!conferma} onHide={() => setConferma(null)} centered>
                <Modal.Header closeButton><Modal.Title>Accendere «{conferma?.nome}»?</Modal.Title></Modal.Header>
                <Modal.Body>
                    Le versioni vecchie dell'app vanno in errore su quello che non conoscono. Accendila solo dopo aver
                    alzato la versione minima dell'app (Impostazioni › Versione dell'app) a una build che la supporta.
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-light btn-add" onClick={() => setConferma(null)}>Annulla</Button>
                    <Button className="btn btn-primary btn-add" onClick={() => salva(conferma.chiave, true)}>Accendi</Button>
                </Modal.Footer>
            </Modal>
            <Card>
                <Card.Body className="sid-card-body--spaced">
                    {FUNZIONI.map((f, i) => (
                        <div key={f.chiave} className={`sid-funzione ${i > 0 ? 'sid-funzione--separata' : ''}`}>
                            <Form.Check
                                type="switch"
                                id={`funzione-${f.chiave}`}
                                label={<strong>{f.nome}</strong>}
                                checked={!!valori[f.chiave]}
                                onChange={(e) => cambia(f, e.target.checked)}
                            />
                            <div className="sid-nota-leggibile mt-1">{f.testo}</div>
                        </div>
                    ))}
                </Card.Body>
            </Card>
            {salvato && <div className="sid-avviso-salvato" role="status">✓ Modifica salvata</div>}
        </>
    );
};

export default Funzioni;
